import { ComponentType, lazy } from 'react';

export const lazyWithPreload = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) => {
  let preloading: Promise<{ default: T }>;
  const Component = lazy(() => preloading || factory());
  const preload = () => preloading || (preloading = factory());
  return [Component, preload] as const;
};
